/**
 * Hujjat qatorining o'ng tugma menyusi (sof funksiya, test: menu.test.ts).
 * Ochish va yuklab olish faqat faylni ocha oladiganlarga (backend `can_open`); ruxsati yo'q amal ko'rsatilmaydi.
 */
import { Archive, CalendarDays, Download, Eye, FilePlus2, Send, Sparkles, Upload } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { DocumentRow, Translate } from "./status";

export interface DocumentMenuActions {
  open: () => void;
  download: () => void;
  /** Fayl yo'q -- yuklash; fayl bor -- "yangi versiya" (shu nusxa arxivlanadi) */
  upload: () => void;
  /** Yana bir nusxa (boshqa shtatdagi yoki yangilangan CDL): mavjudlari qoladi */
  uploadAnother?: () => void;
  request: () => void;
  editDates: () => void;
  archive: () => void;
  /** AI bilan qayta o'qish (OCR sozlangan va fayl bo'lsa) */
  reread?: () => void;
}

export function documentMenu(row: DocumentRow, canOpen: boolean, a: DocumentMenuActions, t: Translate): MenuEntry[] {
  const doc = row.doc;
  const hasFile = !!doc?.has_file;
  return compactMenu([
    hasFile && canOpen && { key: "open", label: t("actions.open"), icon: Eye, onSelect: a.open },
    hasFile && canOpen && { key: "download", label: t("actions.download"), icon: Download, onSelect: a.download },
    { key: "upload", label: hasFile ? t("actions.newVersion") : t("actions.upload"), icon: Upload, onSelect: a.upload },
    hasFile && !row.copy && !!a.uploadAnother && { key: "another", label: t("actions.uploadAnother"), icon: FilePlus2, onSelect: a.uploadAnother },
    !hasFile && !row.copy && { key: "request", label: t("actions.request"), icon: Send, onSelect: a.request, disabled: row.status === "requested" },
    hasFile && { key: "dates", label: t("actions.editDates"), icon: CalendarDays, onSelect: a.editDates },
    hasFile && !!a.reread && doc?.ocr_status !== undefined && doc.ocr_status !== "off" && doc.ocr_status !== "pending" && { key: "reread", label: t("actions.reread"), icon: Sparkles, onSelect: a.reread },
    !!doc && SEPARATOR,
    !!doc && { key: "archive", label: t("actions.archive"), icon: Archive, danger: true, onSelect: a.archive },
  ]);
}
